import { render, staticRenderFns } from "./CountingApprove.vue?vue&type=template&id=47090275"
import script from "./CountingApprove.vue?vue&type=script&lang=js"
export * from "./CountingApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports